"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _recharts = require("recharts");

var _objectHash = _interopRequireDefault(require("object-hash"));

var _Pie = _interopRequireDefault(require("./Pie"));

var _Cell = _interopRequireDefault(require("./Cell"));

var _Legend = _interopRequireDefault(require("./Legend"));

var _RechartsTooltip = _interopRequireDefault(require("./RechartsTooltip"));

var _Mapping, _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Mapping = (_Mapping = {}, (0, _defineProperty2["default"])(_Mapping, _RechartsTooltip["default"].name, _recharts.Tooltip), (0, _defineProperty2["default"])(_Mapping, _Legend["default"].name, _recharts.Legend), (0, _defineProperty2["default"])(_Mapping, _Pie["default"].name, _recharts.Pie), (0, _defineProperty2["default"])(_Mapping, _Cell["default"].name, _recharts.Cell), _Mapping);

var PieChart = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PieChart, _Component);

  var _super = _createSuper(PieChart);

  function PieChart() {
    (0, _classCallCheck2["default"])(this, PieChart);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PieChart, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, null, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, this.props, this.children));
    }
  }, {
    key: "children",

    /* eslint-disable local-rules/unwrapped-i18n */
    get: function get() {
      var childrenProp = this.props.children;
      var allowedChildren = Object.keys(Mapping);

      var children = _react["default"].Children.toArray(childrenProp).filter(function (e) {
        return /*#__PURE__*/_react["default"].isValidElement(e) && allowedChildren.includes(e.type.name);
      });

      var mappedChildren = children.map(function (child) {
        if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
          return null;
        }

        var reactChild = child;
        var childType = reactChild.type;
        var mappedComponent = Mapping[childType.name];
        var childProp = child.props;
        return /*#__PURE__*/_react["default"].createElement(mappedComponent, _objectSpread(_objectSpread({}, childProp), {}, {
          key: (0, _objectHash["default"])({
            name: childType.name
          })
        }));
      });
      return mappedChildren;
    }
  }]);
  return PieChart;
}(_react.Component), _class3.demoProps = {
  dataKey: "value"
}, _class3.demoRender = "\n  <div style={{ flex: 1, height: 300, width: 650 }}>\n    <PieChart width={730} height={250}>\n      <Pie\n        data={[\n          {\n            \"name\": \"Group A\",\n            \"value\": 400\n          },\n          {\n            \"name\": \"Group B\",\n            \"value\": 300\n          },\n          {\n            \"name\": \"Group C\",\n            \"value\": 300\n          },\n          {\n            \"name\": \"Group D\",\n            \"value\": 200\n          },\n          {\n            \"name\": \"Group E\",\n            \"value\": 278\n          },\n          {\n            \"name\": \"Group F\",\n            \"value\": 189\n          }\n        ]}\n        dataKey=\"value\"\n        nameKey=\"name\"\n        outerRadius={50}\n        label\n      />\n    </PieChart>\n  </div>\n", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "children", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "children"), _class2.prototype)), _class2)) || _class;

var _default = PieChart;
exports["default"] = _default;